import React, { useEffect, useState } from 'react'
import "./winners.css"
import fetchWinners from '../../API/fetchWinners'

const weekArray = ["првог", "другог", "трећег", "четвртог", "петог", "шестог"]

const phaseObject = {
    'phase1': 'првог пресека 08.06.2024:',
    'phase2': 'другог пресека 13.06.2024:',
    'phase3': 'трећег пресека 18.06.2024:',
    'phase4': 'четвртог пресека 23.06.2024:',
    'phase5': 'петог пресека 28.06.2024:',
    'phase6': 'шестог пресека 03.07.2024:',
    'phase7': 'првог пресека 08.07.2024:',
    'phase8': 'другог пресека 13.07.2024:',
    'phase9': 'трећег пресека 18.07.2024:',
    'phase10': 'четвртог пресека 23.07.2024:',
    'phase11': 'петог пресека 28.07.2024:',
    'phase12': 'шестог пресека 02.08.2024:'
}
const Winners = () => {

    const [winners, setWinners] = useState([])

    useEffect(() => {
        let fetch = async () => {
            let response = await fetchWinners()

            if (response?.data?.success?.data?.winners) {
                setWinners(response.data.success.data.winners)

            }

        }

        fetch()

    }, [])

    return (
        <div className="content questionsAnswers rulesPage winnersPage">
            <div className="titleMobileDisplay">
                ДОБИТНИЦИ
            </div>

            <div className="qa">
                {Object.entries(winners)
                    .sort((a, b) => b[0].localeCompare(a[0], 'en', { numeric: true }))
                    .map(([key, week], i) => (
                        <div className="item" key={i}>
                            <div className="weekTitle">Добитни кодови {phaseObject[key]} </div>
                            {week.map((prize, prizeIndex) => (
                                <div className="prizeInfo" key={prizeIndex}>
                                    {prize.codes.length > 0 && (
                                        <div className="prizeTitle">
                                            {prizeIndex === 0 && "Сет чаша"}
                                            {prizeIndex === 1 && "Баштенски сет"}
                                            {prizeIndex === 2 && "Ваучер од 2000 евра за опремање кухиње"}
                                            {prizeIndex === 3 && "Аутомобил ШКОДА ОКТАВИЈА"}
                                        </div>
                                    )}

                                    <div className="codes">
                                        {prize.codes.map((code) => (
                                            <span key={code}>{code}, {" "}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
            </div>

        </div>
    )
}

export default Winners